export default __webpack_public_path__ + "static/media/indieoutreach-icon.b1f1e440.png";